import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setTabActive } from "slices/systemAdmin/systemAdminSlice";
import LicenseInfo from "layout/systemAdmin/license/LicenseInfo";
import { fetchLicenseInfo } from "slices/systemAdmin/actions/license";
import LicenseUpload from "layout/systemAdmin/license/LicenseUpload";

const LicenseContent = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setTabActive(2));
    dispatch(fetchLicenseInfo());
  }, [dispatch]);
  return (
    <div className="license__content">
      <LicenseInfo />
      <LicenseUpload />
    </div>
  );
};

export default LicenseContent;
